import React from 'react';

import Image from '@/modules/common/components/Image';
import { SkeletonDark } from '@/modules/common/components/skeleton';

import { useCollectionRoomSelector } from '../../context/CollectionRoomContext';
import { CollectionProduct } from '../../models/collection.interface';
import { AlgoliaProvider } from '../AlgoliaSearch/AlgoliaProvider';
import { CollectionRoomSelectedProduct } from './CollectionRoomSelectedProduct';

export const CollectionRoomExactMatchListCard = () => {
  const productCollection = useCollectionRoomSelector('productCollection');
  const onSelectExactMatchProduct = useCollectionRoomSelector('onSelectExactMatchProduct');
  const exactMatchProducts = useCollectionRoomSelector('exactMatchProducts');
  const isLoadingProducts = useCollectionRoomSelector('isLoadingProducts');

  return (
    <section className="rounded-xl bg-gray-75 py-4 md:px-6 lg:py-8">
      <p className="mb-2 px-4 text-xl font-bold md:mb-3 md:px-0 md:text-2xl">In This Room</p>
      <ul className="mb-6 flex max-w-[90vw] gap-2 overflow-auto px-4 py-1 md:flex-wrap md:px-1">
        {isLoadingProducts ?
          <ListSkeleton />
        : exactMatchProducts?.map((product: CollectionProduct) => (
            <li key={product.sku}>
              <button
                onClick={() => onSelectExactMatchProduct(product)}
                className={`h-14 w-14 overflow-hidden rounded-md ${
                  product.sku === productCollection?.sku && 'ring-2 ring-black ring-offset-2'
                }`}
              >
                <Image
                  src={product.image}
                  className="h-full w-full object-cover"
                  alt={product.name}
                />
              </button>
            </li>
          ))
        }
      </ul>

      <AlgoliaProvider>
        <div className="min-h-52 border-t border-gray-200 px-4 pt-6 md:px-0">
          <CollectionRoomSelectedProduct />
        </div>
      </AlgoliaProvider>
    </section>
  );
};

const ListSkeleton = () =>
  Array.from({ length: 4 }).map((_, index) => (
    <div key={index} className="flex animate-pulse flex-col pb-[1px]">
      <SkeletonDark className="mb-1.5 h-14 w-14" />
    </div>
  ));
